import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { DEFAULT_LANGUAGE_CODE } from '../config/translation.config';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
    const storageService = inject(StorageService);

    // Get language directly from localStorage to ensure we have the most up-to-date value
    const languagePreference = storageService.getLanguagePreference();
    const currentLanguage = languagePreference?.code || DEFAULT_LANGUAGE_CODE;

    const headers: { [key: string]: string } = {};

    // Add Content-Type if not already present
    if (!req.headers.has('Content-Type')) {
        headers['Content-Type'] = 'application/json';
    }

    // Add Accept-Language header with current language
    headers['Accept-Language'] = currentLanguage;

    const request = req.clone({
        setHeaders: headers,
    });

    return next(request);
};
